import type { ReactNode } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Row } from 'react-bootstrap';
import { Button } from '../components/buttons';

/** Пропсы простого информационного модального окна с одной кнопкой «Закрыть». */
export interface ModalMessageProps {
  show?: boolean;
  onHide?: (...args: unknown[]) => unknown;
  title?: ReactNode;
}

const ModalMessage = (props: ModalMessageProps) => {
  const {
    show,
    onHide,
    title,
  } = props;

  return (
    <Modal
      show={ show }
      backdrop='static'
      size='lg'
      aria-labelledby='prompt-modal'
      centered
    >
      <Modal.Header>
        <Modal.Title>
          { title }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className='float-end'>
          <Button
            className='button-margin text-margin'
            variant='primary'
            icon='window-close'
            text='Закрыть'
            onClick={ onHide }
          />
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default ModalMessage;
